export default __webpack_public_path__ + "static/summer-1c5350a5cb493bd00f268318e3e753eb.png";